import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import type { LeadStatus } from '../../types/leads';

const getStatusColor = (status: LeadStatus): string => {
  switch (status) {
    case 'New': return 'blue';
    case 'Disqualified': return 'red';
    default: return 'default';
  }
};

const LeadStatusTag: React.FC<{ status: LeadStatus }> = ({ status }) => {
  const { t } = useTranslation(['sales']);
  return (
    <Tag color={getStatusColor(status)}>
      {t(`sales:leads.status.${status.toLowerCase()}`, status)}
    </Tag>
  );
};

export default LeadStatusTag; 